import { call } from 'redux-saga/effects';
import { eventBus } from 'utils/eventBus';

export function* onLocalStreamExpandedSaga() {
  yield call(eventBus.sendMessage, 'localTileMaximized', {});
}
